<template>
    <div class="main-div">
        <v-header title="业绩报告"></v-header>
        <div class="performanceReportTop">
              <el-form :inline="true" :model="formInline" ref="formInline" :rules="rules" class="demo-form-inline formBox">
                <el-form-item label="报告类型">
                    <el-select v-model="formInline.reportType" placeholder="全部">
                    <el-option v-for="(item, index) in reportTypeList" :label="item.name" :value="item.name" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报告名称" prop="reportName">
                  <el-input v-model="formInline.reportName"></el-input>
                </el-form-item>
                <el-form-item class="onSubmit">
                    <el-button type="primary" :loading="loadings" @click="onSubmit(null)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="middleDataTable" >
            <div class="tableTop">
                <span>报告列表</span>
                <el-button type="primary" @click="addReport">新建报告</el-button>
            </div>
            <el-table :data="teamPersons" style="width: 100" :border="false" :fit="true">
                <el-table-column
                    prop="reportName"
                    label="报告名称"
                    min-width="120"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="reportType"
                    label="报告类型"
                    min-width="100"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="createUser"
                    label="创建人"
                    min-width="180"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    label="创建时间"
                    min-width="100"
                    align="center">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="100"
                    align="center">
                    <template slot-scope="scope">
                        <el-button @click="compileClick(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row type="flex" class="row-bg" justify="center">
                <el-col class="pages">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout="total, prev, pager, next, jumper"
                        :total="itemCount">
                    </el-pagination>
                </el-col>
            </el-row>
            <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="show" v-if="show" :show-close="false" center>
                 <el-form :model="report" :rules="reportLules" ref="report">
                    <el-form-item label="报告名称" class="reportNameClass" prop="name">
                        <el-input v-model="report.name" autocomplete="off" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="报告类型" class="reportTypeClass">
                        <el-select v-model="report.type" clearable>
                        <el-option v-for="(item, index) in reportTypeListNew" :label="item.name" :value="item.name" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <label for="">报告文件上传</label>
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      :action="uploadUrl"
                      :data="uploadData"
                      :headers="uploadHeader"
                      :on-remove="handleRemove"
                      :on-success="( res, file)=> uploadAudioSuccess(res, file)"
                      :limit='1'
                      :file-list="fileList"
                      accept='.pdf'
                      :before-upload="beforeUpload"
                      :on-exceed="handlExceed"
                      :on-change="handleChange"
                      :show-file-list="true">
                      <el-button size="small" type="primary" class="selectFile">选择文件</el-button><span v-if="fileShow" class="tag">未选择任何文件</span>
                      <div slot="tip" class="el-upload__tip">* 仅支持pdf格式，文件大小不超过5M</div>
                    </el-upload>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="countermandClick">取 消</el-button>
                    <el-button type="primary" @click="holdClick" :disabled="fileShow || !report.name || !report.type || !fileUrl">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import getIP from '@/components/utils/getIP'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    let str = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
    var reportNames = (rule, value, callback) => {
      let msg = this.test(value)
      if (!value) {
        return;
      }else if (!str.test(value)) {
        callback(new Error('报告名称只可输入数字字母汉字'));
        return;
      } else if (msg.hz * 2 + msg.fhz * 2 > 60) {
        callback(new Error('报告名称不可超过30个中文字符'));
        return;
      } else {
        callback();
      }
    };
    var names = (rule, value, callback) => {
      let msg = this.test(value)
      if (!value) {
        return;
      }else if (!str.test(value)) {
        callback(new Error('报告名称只可输入数字字母汉字'));
        return;
      } else if (msg.hz * 2 + msg.fhz * 2 > 60) {
        callback(new Error('报告名称不可超过30个中文字符'));
        return;
      } else {
        callback();
      }
    };
    return {
      formInline: {
        reportType: '全部',
        reportName: ''
      },
      reportTypeList: [{name: '全部', code: 0}, {name: '季报', code: 1}, {name: '半年报', code: 2}, {name: '年报', code: 3}],
      reportTypeListNew: [{name: '季报', code: 1}, {name: '半年报', code: 2}, {name: '年报', code: 3}],
      currentPage: 1,
      itemCount: 0,
      teamPersons: [],
      loadings: false,
      show: false,
      fileShow: true,
      uploadData: {
        'domain': 'TRAIN',
        'buz': 'FILE',
        'expired': 60, // -1
        'actions': '',
        'buzId': '123',
        'auth': 1
      },
      uploadUrl: process.env.UPLOAD_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/upload',
      uploadHeader: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionStorage.getItem('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.getItem('username')
      },
      title: '新建报告',
      report: {
        name: '',
        type: ''
      },
      fileList: [],
      fileName: '',
      fileUrl: '',
      id: '',
      rules: {
        reportName: [
          { validator: reportNames, trigger: 'change' }
        ]
      },
      reportLules: {
        name: [
          { validator: names, trigger: 'change' }
        ]
      },
    };
  },
  watch: {},
  methods: {
    test (str) {
      var reg1 = /([\u4e00-\u9fa5]*)/g
      var reg2 = /([\dA-Za-z]*)/g
      return {
        'hz': str.match(reg1).join('').length,
        'fhz': str.match(reg2).join('').length
      }
    },
    beforeUpload (file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const whiteList = ['pdf', 'PDF']
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message({
          type: 'error',
          message: '上传文件只能是 pdf或PDF格式'
        })
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message({
          type: 'error',
          message: '上传文件大小不能超过 5MB'
        })
        return false
      }
    },
    // 上传文件成功回调
    uploadAudioSuccess (res, file) {
      console.log('res', res)
      console.log('file', file)
      if (res.result.isSuccess) {
        this.fileName = file.name
        this.fileUrl = file.response.data.fileId + '.' + file.response.data.ext
        console.log('this.fileName', this.fileName)
        console.log('this.fileUrl', this.fileUrl)
      } else {
        this.$message({
          type: 'error',
          message: res.result.error
        });
      }
    },
    // 整个页面的加载
    loading () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 1000);
    },
    // 切换分页
    handleCurrentChange (c,p) {
      console.log('c', c)
      this.currentPage = c
      this.onSubmit('tag')
    },
    // 点击编辑
    compileClick (v) {
      this.title = '编辑报告'
      this.show = true
      this.report.name = v.reportName
      this.report.type = v.reportType
      this.fileName = v.reportFileName
      this.fileUrl = v.reportFile
      this.id = v.id
      this.fileList = [{name: v.reportFileName, url: v.reportFile}]
      this.fileShow = false
      console.log('编辑', v)
    },
    // 点击删除
    deleteClick (v) {
      console.log('删除', v)
      this.$confirm('此操作将永久删除该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: v.id
        }
        console.log('params', params)
        api.post(url.deleteTeamPerformanceReport, params, res => {
          console.log('res', res);
          if (res.result.isSuccess) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onSubmit();
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 点击新建
    addReport () {
      console.log('新建报告')
      this.title = '新建报告'
      this.show = true
    },
    // 点击查询
    onSubmit (v = null) {
      console.log('v', v)
      if (!v) {
        this.currentPage = 1
      }
      console.log('查询')
      let params = {
        reportType: this.formInline.reportType, // 报告类型
        reportName: this.formInline.reportName, // 报告名称
        pageParamReqVo: {
          pageCount: 10, // 每页条数
          page: v ? this.currentPage : 1 // 当前页
        },
        // teamCode: '123123'
      }
      console.log('params', params)
      this.loadings = true;
      if (this.formInline.reportName === '') {
        api.post(url.getTeamPerformanceReportPC, params, res => {
          console.log('res', res);
          if (res.result.isSuccess) {
            this.loading()
            this.loadings = false;
            this.itemCount = res.data.count
            this.teamPersons = res.data.performanceReportList
            sessionStorage.setItem('teamCode', res.data.teamCode)
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        })
        return;
      }
      this.$refs['formInline'].validate((valid) => {
        if (valid) {
          api.post(url.getTeamPerformanceReportPC, params, res => {
            console.log('res', res);
            if (res.result.isSuccess) {
              this.loading()
              this.loadings = false;
              this.itemCount = res.data.count
              this.teamPersons = res.data.performanceReportList
              sessionStorage.setItem('teamCode', res.data.teamCode)
            } else {
              this.$message({
                type: 'error',
                message: res.result.error
              });
            }
          })
        } else {
          this.loadings = false;
          this.$message.error('输入的报告名称不符合规范，请重新输入');
        }
      })
    },
    // 点击取消
    countermandClick () {
      console.log('取消')
      this.fileUrl = ''
      this.fileName = ''
      this.report.name = ''
      this.report.type = ''
      this.fileList = []
      this.id = ''
      this.fileShow = true
      this.show = false
    },
    // 点击保存
    holdClick () {
      console.log('保存')
      let params = {
        reportType: this.report.type, // 报告类型
        reportName: this.report.name, // 报告名称
        reportFileName: this.fileName, // 文件名
        reportFile: this.fileUrl, // 文件URL
        // teamCode: '123123',
        teamCode: sessionStorage.getItem('teamCode'),
        id: this.id || '',
      }
      console.log('params', params)
      this.$refs['report'].validate((valid) => {
        if (valid) {
          api.post(url.saveOrUpdateTeamPerformanceReport, params, res => {
            console.log('res', res);
            if (res.result.isSuccess) {
              this.$message({
                type: 'success',
                message: '保存成功!'
              });
              this.countermandClick()
              this.onSubmit();
            } else {
              this.$message({
                type: 'error',
                message: res.result.error
              });
            }
          })
        } else {
          this.$message.error('输入的报告名称不符合规范，请重新输入');
        }
      })
    },
    // 删除文件
    handleRemove (file, fileList) {
      console.log('handleRemove', file, fileList)
      this.fileUrl = ''
      this.fileName = ''
      this.fileShow = true
    },
    // 选择文件
    handleChange (file, fileList) {
      this.fileShow = false
      console.log('handleChange', file, fileList)
    },
    // 校验是否有文件存在
    handlExceed (file, fileList) {
      console.log('handlExceed', file, fileList)
      this.$message({
        message: '请先删除已上传的报告',
        type: 'warning'
      })
    }
  },
  mounted () {
    this.onSubmit()
  },
  activated () {}
}
</script>

<style scoped>
.main-div{
    height: 100%;
    width: 96%;
    margin: 0 auto;
}
.performanceReportTop {
    margin-top: 90px;
}
.performanceReportTop .formBox {
    display: flex;
    justify-content: flex-start;
}
.performanceReportTop .onSubmit {
  /* margin-left: 30%; */
}
.performanceReportTop .onSubmit button{
  width: 96px;
}
.middleDataTable .tableTop{
    width: 100%;
    height: 50px;
    background: #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
}
.pages{
  display:flex;
  justify-content: center;
  align-items:center;
  background-color: #ffffff;
  height: 100px;
}
.reportNameClass {
  display: flex;
}
.reportNameClass /deep/ .el-form-item__label {
  width: 15%;
  text-align: left;
}
.reportNameClass /deep/ .el-form-item__content {
  width: 70%;
}
.reportTypeClass {
  display: flex;
}
.reportTypeClass /deep/ .el-form-item__label {
  width: 15%;
  text-align: left;
}
.reportTypeClass /deep/ .el-form-item__content {
  width: 50%;
}
.upload-demo {
  padding: 5% 15%;
}
.tag {
  margin-left: 5px;
}
.el-upload__tip {
  margin-top: 10px;
  color: red;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
  padding: 0 20%;
}
.performanceReportTop >>> .el-form--inline .el-form-item {
  margin-right: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/performanceReportManagement.vue